import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bed186de"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pay"
}
const _hoisted_2 = { class: "head" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "username" }
const _hoisted_6 = { class: "user_privliege" }
const _hoisted_7 = { class: "countdown" }
const _hoisted_8 = { class: "box" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 距离今天活动结束： ")
const _hoisted_10 = { class: "text" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("时 ")
const _hoisted_12 = { class: "text" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("分 ")
const _hoisted_14 = { class: "text" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("秒 ")
const _hoisted_16 = { class: "text longer" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("毫秒 ")
const _hoisted_18 = { class: "package_list" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "name" }
const _hoisted_21 = { class: "prices" }
const _hoisted_22 = { class: "price_real" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rmb_symbol" }, "¥", -1))
const _hoisted_24 = { class: "price_original" }
const _hoisted_25 = { class: "tip_footer" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hook" }, null, -1))
const _hoisted_27 = {
  key: 0,
  class: "count_down"
}
const _hoisted_28 = {
  key: 0,
  class: "tip ad"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hook" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "recommend" }, "推荐", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip wx_pay" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wx_pay" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "icon" }),
    /*#__PURE__*/_createElementVNode("span", null, "微信支付")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "hook" })
], -1))
const _hoisted_32 = { class: "privliege" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "privliege_head" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box" }),
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "会员特权")
], -1))
const _hoisted_34 = { class: "privliege_body" }
const _hoisted_35 = { class: "privliege_text" }
const _hoisted_36 = { class: "to_pay" }
const _hoisted_37 = { class: "left" }
const _hoisted_38 = { class: "price_text" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "实付：", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rmb_symbol" }, "¥", -1))
const _hoisted_41 = { class: "amount" }
const _hoisted_42 = { class: "protocol_text" }
const _hoisted_43 = { class: "text" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("已阅读并同意  ")
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" 及 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaySuccess = _resolveComponent("PaySuccess")!
  const _component_AcceptProtocol = _resolveComponent("AcceptProtocol")!
  const _component_TipDialog = _resolveComponent("TipDialog")!

  return (_ctx.packageHandle.list.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            ref: "imgAvatarRef",
            src: _ctx.userHandle.userInfo.avatar_url,
            class: "avatar",
            onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.userHandle.imgAvatarError && _ctx.userHandle.imgAvatarError(...args)))
          }, null, 40, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.userHandle.userInfo.username), 1),
            _createElementVNode("span", _hoisted_6, "身份：" + _toDisplayString(_ctx.userHandle.userInfo.privliegeName), 1)
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.countdownHandle.countdownObj.h), 1),
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.countdownHandle.countdownObj.m), 1),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.countdownHandle.countdownObj.s), 1),
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.countdownHandle.countdownObj.ms), 1),
            _hoisted_17
          ])
        ], 512), [
          [_vShow, _ctx.packageHandle.isSelectForever && _ctx.countdownHandle.isShow]
        ]),
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packageHandle.list, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.name,
              class: _normalizeClass(['package', { is_select: _ctx.packageHandle.isSelect(item) }]),
              onClick: ($event: any) => (_ctx.packageHandle.selectPackage(item))
            }, [
              _createElementVNode("div", _hoisted_20, _toDisplayString(item.name), 1),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("span", null, _toDisplayString(item.priceReal), 1)
                ]),
                _createElementVNode("span", _hoisted_24, " ¥" + _toDisplayString(item.priceOriginal), 1)
              ]),
              _createElementVNode("div", _hoisted_25, _toDisplayString(item.tipFooter), 1),
              _hoisted_26,
              (_ctx.packageHandle.isPackageForever(item))
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, " 剩余名额：" + _toDisplayString(_ctx.leftCountHandle.count), 1))
                : _createCommentVNode("", true)
            ], 10, _hoisted_19))
          }), 128))
        ]),
        (_ctx.packageHandle.isSelectForever && _ctx.tipHanle.tipForeverVip)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("span", null, _toDisplayString(_ctx.tipHanle.tipForeverVip), 1),
              _hoisted_29,
              _hoisted_30
            ]))
          : _createCommentVNode("", true),
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.privliegeHandle.privliegeListLayout, (privliegeList, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "privliege_container_container"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(privliegeList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.value,
                    class: "privliege_container"
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['icon_privliege', item.value])
                    }, null, 2),
                    _createElementVNode("div", _hoisted_35, _toDisplayString(item.name), 1)
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _hoisted_40,
              _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.packageHandle.packageSelect.priceReal), 1)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", {
                class: _normalizeClass(['icon_checkbox', _ctx.protocolHandle.isAgree ? 'selected' : 'default']),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.protocolHandle.toggle && _ctx.protocolHandle.toggle(...args)))
              }, null, 2),
              _createElementVNode("span", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("span", {
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.protocolHandle.openUserProtocol && _ctx.protocolHandle.openUserProtocol(...args)), ["stop"])),
                  class: "link"
                }, "用户协议"),
                _hoisted_45,
                _createElementVNode("span", {
                  onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.protocolHandle.openPrivacyPolicy && _ctx.protocolHandle.openPrivacyPolicy(...args)), ["stop"])),
                  class: "link"
                }, "隐私政策")
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: "right",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.packageHandle.clickPay && _ctx.packageHandle.clickPay(...args)))
          }, " 立即支付 ")
        ]),
        _withDirectives(_createVNode(_component_PaySuccess, {
          onClose: _ctx.paySuccessHandle.close
        }, null, 8, ["onClose"]), [
          [_vShow, _ctx.paySuccessHandle.isShow]
        ]),
        _createVNode(_component_AcceptProtocol, {
          visible: _ctx.protocolHandle.isShowAcceptModal,
          onConfirm: _ctx.onAcceptModalConfirm,
          onCancel: _ctx.onAcceptModalCancel,
          onOpenUserProtocol: _ctx.protocolHandle.openUserProtocol,
          onOpenPrivacyProtocol: _ctx.protocolHandle.openPrivacyPolicy
        }, null, 8, ["visible", "onConfirm", "onCancel", "onOpenUserProtocol", "onOpenPrivacyProtocol"]),
        _withDirectives(_createVNode(_component_TipDialog, {
          onEmitClickClose: _ctx.tipDialog.emitClickClose,
          onEmitClickSelfBtn: _ctx.tipDialog.emitClickSelfBtn
        }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.tipDialog.title), 1)
          ]),
          body: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.tipDialog.desc), 1)
          ]),
          _: 1
        }, 8, ["onEmitClickClose", "onEmitClickSelfBtn"]), [
          [_vShow, _ctx.tipDialog.visible]
        ])
      ]))
    : _createCommentVNode("", true)
}